export default "__VITE_ASSET__DWSlsres__"